import axios, { voyagerIntegratorInstance } from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getMisWorklistAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mis/worklist`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getMisSubmittedForverificationAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mis/submitted-for-verification`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getMisParkedAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mis/parked`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getSubmittedToTypistAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mis/submitted-to-typist-reports`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const getMisVerifiedAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mis/verified`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getVisitReportAPI = async (risId, reportId, visitNo) => {
    return await axios.get(`/api/v1/mis/visit-report`, {
        params: {
            risId,
            reportId,
            visitNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, visitReport: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const updateVisitReportStateAPI = async (data) => {
    return await axios.post(`/api/v1/mis/update-visit-report-state`, data)
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, visit: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const undoReportFromHoldQueueAPI = async (params) => {
    return await axios.get(`/api/v1/mis/undo-report-from-hold-queue`, {
        params,
    })
        .then(function (response) {
            if (response.data) {
                return { success: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const releaseReportFromHoldQueueAPI = async (reportId) => {
    return await axios.get(`/api/v1/mis/release-report-from-hold-queue`, {
        params: { reportId },
    })
        .then(function (response) {
            return { success: !!response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getHistoryReportsByFilterParams = async (data) => {
    return await axios.post(`/api/v1/mis/history-reports-by-filter-params`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, historyReports: response.data };
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error };
        })
}

export const getPatientHistoryReportsAPI = async (patientId) => {
    return await axios.get(`/api/v1/mis/patient-history-reports`, {
        params: {
            patientId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, patientHistoryReports: response.data };
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error };
        })
}

export const getWorklistAutoNextVisitAPI = async (data) => {
    return await axios.post(`/api/v1/mis/worklist-auto-next-visit`, data)
        .then(function (response) {
            return { success: true, report: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getsubmittedForVerificationAutoNextVisitAPI = async (data) => {
    return await axios.post(`/api/v1/mis/submitted-for-verification-auto-next-visit`, data)
        .then(function (response) {
            return { success: true, report: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getAutoNextParkedVisitAPI = async (data) => {
    return await axios.post(`/api/v1/mis/auto-next-parked-visit`, data)
        .then(function (response) {
            return { success: true, report: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getCoReportersAPI = async (reportId) => {
    return await axios.get(`/api/v1/mis/mis2-usernames`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}


export const assignedMis2API = async (payload) => {

    return await axios.get(`/api/v1/mis/assign-mis2`,
        {
            params: {
                'mis2UserId': payload.mis2UserId,
                'reportId': payload.reportId
            }
        }).then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, }
            }
        }).catch(function (error) {
            return { success: false, error };
        });
}

export const sendReportAsAddendumAPI = async (data) => {
    return await axios.post(`/api/v1/mis/send-report-as-addendum`, data)
        .then(function (response) {
            return { success: true, report: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const unassignMis1API = async (reportId) => {
    return await axios.get(`/api/v1/mis/unassign-mis1`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            return { success: true, visit: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const openVoyagerAPI = async (accessionNumber) => {
    return await voyagerIntegratorInstance.get(`/api/v1/invoke`, {
        params: {
            study: 'openstudy',
            accessionNumber
        }
    })
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const closeVoyagerAPI = async (accessionNumber, isReported) => {
    return await voyagerIntegratorInstance.get(`/api/v1/close`, {
        params: {
            study: 'closestudy',
            accessionNumber,
            isReported
        }
    })
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const hideTypistReasonAPI = async (orderNo, userId) => {
    return await axios.patch(`/api/v1/hide-typist-reason?orderNo=${orderNo}&userId=${userId}`)
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
